import { ActionTypes } from "../Constants/ActionTypes";


export const homeSelectedQuickLinkIndex = (selectedQuickLinkIndex) => {
    return{
        type: ActionTypes.QUICK_LINK_SELECTED_INDEX,
        payload: selectedQuickLinkIndex
    }
}

export const homeSelectedQuickLink = (quickLinkData)=> {
    return{
        type: ActionTypes.SELCTED_QUICK_LINK,
        payload: quickLinkData
    }
}